module.exports = __webpack_public_path__ + "static/media/icon-view-satisfied.d7f4be1c.svg";